# Naive check to see if it looks like the text contains a URL
# This doesn't make any attempt to reject obviously bad URLs like
# http://? http://:abc http:/// etc
module.exports = (text) ->
  ///
  ^
  https?://         # Must start with an http/https protocol
  \S+               # Can't contain any whitespace
  $
  ///.test(text)
